import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { ThemeProvider, useTheme, useUpdateThemeWithFontBrightness, } from '@design-system/theme';
import { useGetVariant } from './hooks/useGetVariant';
export const AppHeader = ({ controls, coverPicture, coverPictureNarrow, coverPictureWide, dataTestId, description, disableCoverPicture, disableDescription, isPreview, mb, title, }) => {
    const theme = useTheme();
    const updatedTheme = useUpdateThemeWithFontBrightness(theme, theme.themeVariables.appHeaderFontBrightness);
    const componentVariant = useGetVariant({
        controls,
        coverPicture,
        coverPictureNarrow,
        coverPictureWide,
        description,
        disableCoverPicture,
        disableDescription,
        isPreview,
        title,
    });
    return (_jsx(Box, { bg: theme.themeVariables.appHeaderBackgroundColor, dataTestId: dataTestId, mb: mb, width: "100%", children: _jsx(ThemeProvider, { theme: updatedTheme, children: componentVariant }) }));
};
//# sourceMappingURL=AppHeader.js.map